
export const PatchNames = {
    2.0: "A Realm Reborn",
    2.1: "A Realm Reborn - A Realm Awoken",
    2.2: "A Realm Reborn - Through the Maelstrom",
    2.3: "A Realm Reborn - Defenders of Eorzea",
    2.4: "A Realm Reborn - Dreams of Ice",
    2.5: "A Realm Reborn - Before the Fall",

    3.0: "Heavensward",
    3.1: "Heavensward - As Goes Light, So Goes Darkness",
    3.2: "Heavensward - The Gears of Change",
    3.3: "Heavensward - Revenge of the Horde",
    3.4: "Heavensward - Soul Surrender",
    3.5: "Heavensward - The Far Edge of Fate",

    4.0: "Stormblood",
    4.1: "Stormblood - The Legend Returns",
    4.2: "Stormblood - Rise of a New Sun",
    4.3: "Stormblood - Under the Moonlight",
    4.4: "Stormblood - Prelude in Violet",
    4.5: "Stormblood - A Requiem for Heroes",

    5.0: "Shadowbringers",
    5.1: "Shadowbringers - Vows of Virtue, Deeds of Cruelty",
    5.2: "Shadowbringers - Echoes of a Fallen Star",
    5.3: "Shadowbringers - Reflections in Crystal",
    5.4: "Shadowbringers - Futures Rewritten",
    5.5: "Shadowbringers - Death Unto Dawn",

    6.0: "Endwalker",
    6.1: "Endwalker - Newfound Adventure",
    6.2: "Endwalker - Buried Memory",
    6.3: "Endwalker - Gods Revel, Lands Tremble",
    6.4: "Endwalker - The Dark Throne",
    6.5: "Endwalker - Growing Light",

    7.0: "Dawntrail",
    7.1: "Dawntrail - Crossroads"
  };